import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const SettingsContext = createContext(null);

const DEFAULTS = {
  showroom_name: "Car Showroom",

  currency_code: "OMR",
  currency_symbol: "OMR",
  currency_decimals: 3,
  locale: "en-OM",
  timezone: "Asia/Muscat",
  date_format: "DD/MM/YYYY",
  days_in_stock_threshold: 60,
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [ready, setReady] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/settings/public");
      setSettings({ ...DEFAULTS, ...data });
    } catch {
      setSettings(DEFAULTS);
    } finally {
      setReady(true);
    }
  }, []);

  const loadFull = useCallback(async () => {
    const { data } = await api.get("/settings");
    setSettings({ ...DEFAULTS, ...data });
    return data;
  }, []);

  const saveSettings = useCallback(async (patch) => {
    const { data } = await api.put("/settings", patch);
    setSettings({ ...DEFAULTS, ...data });
    return data;
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    if (settings.showroom_name) document.title = settings.showroom_name;
    if (settings.favicon_url) {
      let link = document.querySelector("link[rel*='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = settings.favicon_url;
    }
  }, [settings]);

  return (
    <SettingsContext.Provider value={{ settings, ready, reload: load, loadFull, saveSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);

export function formatMoney(amount, s) {
  if (amount == null || amount === "") return "—";
  const decimals = s?.currency_decimals ?? 3;
  const symbol = s?.currency_symbol || s?.currency_code || "OMR";
  try {
    const n = Number(amount);
    if (Number.isNaN(n)) return "—";
    return `${symbol} ${n.toLocaleString("en-US", { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}`;
  } catch {
    return `${symbol} ${amount}`;
  }
}

export function formatNumber(n) {
  if (n == null) return "—";
  return Number(n).toLocaleString("en-US");
}
